import axios from "axios";

const changeEmailUrl = '/rest/profile/change-email';
const profileDeactivateUrl = '/rest/user/deactivate';

const deleteAccountTextTemplate = 'delete my account';
const redButtonClass = 'button--white-with-red-text';
const buttonDeleteAccountSelector = '.btn-delete-account';
const submitButtonSelector = '.modal#change-email .button.button--red';
const emailFieldSelector = '#changeemailform-email';
const passwordFieldSelector = '#changeemailform-password';

export const bindEventsOnProfile = () => {
    $( '#settings-password input:password' ).val('');

    $('.user-info__avatar-edit-link').click(function () {
        $('input[type="file"]').trigger('click');
    });

    $('.user-info__avatar-wrapper input[type="file"]').change(function () {
        $(this).parents('form').submit();
    });

    $('#settings-password input').change(function () {
        if (checkReadyPasswordInputs()) {
            $('#settings-password-submit').removeAttr('disabled');
        }
    });

    $('.modal-body__cancel').click(function () {
        $(this).parents('.modal-dialog').find('.close').click();
    });

    $(document).on('click', submitButtonSelector, function () {
        const $form = $(this).closest('form');
        $form.yiiActiveForm('validate');

        axios.post(changeEmailUrl, {
            password: $form.find(passwordFieldSelector).val(),
            email: $form.find(emailFieldSelector).val()
        })
            .then(() => {
                window.location.href = '/';
            }).catch(error => {
            const {data, status} = error.response;
            const {message, code} = data;

            if (status === 417) {
                const errorFields = JSON.parse(message);

                const messages = Object.entries(errorFields).reduce((acc, [key, value]) => {
                    acc['changeemailform-' + key] = value;

                    return acc;
                }, {});

                $form.yiiActiveForm('updateMessages', messages)
            }

            if (status !== 400) {
                return;
            }

            if (code === 701) {
                $form.yiiActiveForm('updateMessages', {'changeemailform-password': [message]})

                return;
            }

            if (code === 409) {
                $('.modal#change-email').modal().hide();
                $('.modal#email-change-conflict').modal().show();
            }
        });
    });

    $('.modal#change-email form').on('submit', function (e) {
        e.preventDefault();
        console.log('test-n-rest')
    });

    $('.profile-email-change-button').on('click', () => {
        $('.modal#change-email').modal().show();
    });

    $('#email-account-submit').click(function () {
        const modal= $($(this).data('target'));

        modal.find('.modal-body__title').show();
        modal.find('.modal-body__title.is-social').hide();
        modal.find('.modal-body__content>.form-group').show();
        modal.find('.button.button--red').show();

        if($(this).data('isSocial')){
            modal.find('.modal-body__title').hide();
            modal.find('.modal-body__title.is-social').show();
            modal.find('.modal-body__content>.form-group').hide();
            modal.find('.button.button--red').hide();

            modal.modal('show');
            return false;
        }

        modal.modal('show');

        return false;
    });

    $('.profile-modal-delete-confirmation-input').on('input', e => {
        const $target = $(e.target);
        const text = typeof $target.val() === 'string' ?  $target.val().trim() : '';
        const $deleteButton = $target.siblings().children(buttonDeleteAccountSelector);

        if (text === deleteAccountTextTemplate) {
            $deleteButton.addClass(redButtonClass);

            return;
        }

        $deleteButton.removeClass(redButtonClass);
    });

    $(buttonDeleteAccountSelector).click(e => {
        const $target = $(e.target);
        const userId = $target.data('userId');

        if (!$target.hasClass(redButtonClass)) {
            alert(`To delete your account please type "${deleteAccountTextTemplate}" without quotes to form input`);

            return;
        }

        axios.post(profileDeactivateUrl, {id: userId})
            .then(() => {
                window.location.replace('/logout');
            })
            .catch(e => {
                console.log(e);
            });
    });

    $('.two-years-indie-upgrade-now-button').on('click', () => {
        window.location.href = '/twoyearsusers/yearly-pro/buy';
    });
};

const checkReadyPasswordInputs = () => {
    let inputsReady = 0;

    $('#settings-password input').each(function (index, el) {
        if ($(this).val().length > 0) {
            inputsReady++;
        }
    });

    return inputsReady === 4;
};
